import { SET_LOCALE } from '../actionTypes';

/**
 * Set the Mame Language
 * @param {string} locale
 * @return {{payload: {locale}, type: string}}
 */
export const setLocale = locale => ({type: SET_LOCALE, payload: {locale}});
